// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".init-user-cert-dialog.common-dialog[data-v-a05c39e2] .el-dialog{width:var(--common-dialog-width)}.init-user-cert-dialog.common-dialog .el-form[data-v-a05c39e2]{margin-right:var(--common-dialog-form-margin-right)}.init-user-cert-dialog.common-dialog .common-icon[data-v-a05c39e2]{vertical-align:middle;font-size:var(--common-dialogize)}", ""]);
// Exports
module.exports = exports;
